import EnumSet from 'Services/enumSet'

export interface IPlanContainerTypes extends EnumSet {
  diamond: number
  elite: number
  advanced: number
  medium: number
  basic: number
  demand: number
}

const AppPlanNames = new EnumSet({
  diamond: { value: 1, description: 'Diamante' },
  elite: { value: 2, description: 'Elite' },
  advanced: { value: 3, description: 'Avançado' },
  medium: { value: 4, description: 'Padrão' },
  basic: { value: 5, description: 'Básico' },
  demand: { value: 6, description: 'Sob demanda' },
}) as IPlanContainerTypes

export default AppPlanNames